<template>
  <div id="rentasVigentes">
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <v-toolbar card color="white">
            <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Búsqueda rápida"
              v-model="search"
              hide-details
              class="hidden-sm-and-down"
            ></v-text-field>
            <v-btn icon>
              <v-icon>filter_list</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :search="search"
              :items="rentas"
              :rows-per-page-items="[10, 25, 50, { text: 'Todos', value: -1 }]"
              class="elevation-1"
              item-key="rentaId"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.folioRenta }}</td>
                <td>{{ props.item.nombreCliente }}</td>
                <!-- <td>{{ props.item.celularCliente }}</td>
                <td>{{ props.item.correoCliente }}</td> -->
                <td>{{ props.item.fechaRenta.substring(0, 10) }}</td>
                <td>{{ props.item.fechaRecoleccion.substring(0, 10) }}</td>
                <td>{{ props.item.fechaEvento.substring(0, 10) }}</td>
                <td>{{ props.item.fechaEntrega.substring(0, 10) }}</td>
                <!-- <td>$ {{ formatMoney(props.item.totalFinal) }}</td>
                <td>$ {{ formatMoney(props.item.pagado) }}</td> -->
                <!-- <td>{{ props.item.descripcionEvento }}</td> -->
                <td>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    @click="getRenta(props.item.rentaId)"
                    title="Visualizar renta"
                  >
                    <v-icon>pageview</v-icon>
                  </v-btn>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    small
                    @click="descargarTicketRenta(props.item.rentaId)"
                    title="Reimprimir ticket"
                  >
                    <v-icon>print</v-icon>
                  </v-btn>
                </td>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
                outline
                >La búsqueda para "{{ search }}" no encontró registros</v-alert
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <loading-alert :show="showCargando"></loading-alert>
    <form-desglose-renta
      v-if="loadForms"
      ref="formDesgloseRenta"
      :renta="rentaSeleccionada"
      @onPagoAdded="onPagoAdded"
      @onPagoUpdated="onPagoUpdated"
      @onPagoDeleted="onPagoDeleted"
    ></form-desglose-renta>
    <form-bitacora-renta
      v-if="loadForms"
      ref="formBitacoraRenta"
      :rentaBitacora="rentaBitacora"
      :renta="rentaSeleccionada"
      :nuevoEvento="true"
      :readOnly="true"
      @onBitacoraAdded="onBitacoraAdded"
    ></form-bitacora-renta>
    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import moment from "moment";
import { apiHost } from "@/config";

//Global Components
import loadingAlert from "@/components/LoadingAlertManual";
import VWidget from "@/components/VWidget";
import confirm from "@/components/dialogs/Confirm";

//Local Components
import formDesgloseRenta from "@/views/rentas/FormDesgloseRenta";
import formBitacoraRenta from "@/views/renta-bitacora/FormBitacoraRenta";

//Services
import rentaService from "@/services/rentaService";

export default {
  components: {
    VWidget,
    loadingAlert,
    confirm,
    formDesgloseRenta,
    formBitacoraRenta,
  },
  props: {
    sucursal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showCargando: false,
      loadForms: false,
      search: "",
      headers: [
        { text: "FOLIO", align: "center", value: "folioRenta" },
        { text: "CLIENTE", align: "center", value: "nombreCliente" },
        // { text: "CELULAR", align: "center", value: "celularCliente" },
        // { text: "CORREO", align: "center", value: "correoCliente" },
        { text: "FECHA RENTA", align: "center", value: "fechaRenta" },
        {
          text: "FECHA RECOLECCIÓN",
          align: "center",
          value: "fechaRecoleccion",
        },
        {
          text: "FECHA EVENTO",
          align: "center",
          value: "fechaEvento",
        },
        {
          text: "FECHA ENTREGA",
          align: "center",
          value: "fechaEntrega",
        },
        // { text: "TOTAL", align: "center", value: "totalFinal" },
        // { text: "PAGADO", align: "center", value: "pagado" },
        // { text: "EVENTO", align: "center", value: "descripcionEvento" },
        { text: "ACCIONES", value: "acciones", align: "center" },
      ],
      rentas: [],
      rentaSeleccionada: {
        rentaId: 0,
        folioRenta: "",
        clienteId: "",
        cliente: {},
        fechaRenta: moment(new Date()).format("YYYY-MM-DD"),
        fechaRecoleccion: null,
        fechaEvento: null,
        fechaEntrega: null,
        subtotal: 0,
        porcentajeDescuento: 0,
        total: 0,
        iva: 0,
        totalFinal: 0,
        pagado: 0,
        eventoRentaId: 0,
        eventoRenta: {},
        sucursalId: 0,
        desgloseProductos: [],
        desgloseConjunto: [],
        desglosePagos: [],
        desgloseBitacora: [],
      },
      showToolTipCancel: false,
      rentaBitacora: {
        rentaId: 0,
        eventoRentaId: 5,
        fechaEvento: moment(new Date()).format("YYYY-MM-DD"),
        comentarios: "",
        anexoEvento: "",
      },
    };
  },
  watch: {
    sucursal: function (n) {
      //this.getRentas(n.sucursalId);
    },
  },
  computed: {
    fechaHoy: function () {
      return this.getDate();
    },
  },
  methods: {
    getRentas(catalogoRowId) {
      let self = this;
      self.loadForms = true;
      self.showCargando = true;
      rentaService
        .getByCatalogoProducto(catalogoRowId, self.sucursal.sucursalId)
        .then((result) => {
          self.rentas = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.showCargando = false;
        });
    },
    pushRenta(renta) {
      let self = this;
      self.rentas.push(renta);
    },
    getRenta(rentaId) {
      let self = this;

      self.showCargando = true;

      rentaService
        .get(rentaId)
        .then((result) => {
          self.$store.state.tituloForm = "VISUALIZAR RENTA";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";
          self.rentaSeleccionada = result;
          self.$refs.formDesgloseRenta.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.showCargando = false;
        });
    },
    descargarTicketRenta(id) {
      var h = 900;
      var w = 400;
      var left = screen.width / 2 - w / 2;
      var top = screen.height / 2 - h / 2;
      var titulo = "VISUALIZACIÓN DEL DOCUMENTO";

      let self = this;
      self.showCargando = true;
      rentaService
        .getTicketRenta(id)
        .then((result) => {
          var byteCharacters = atob(result);
          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          var byteArray = new Uint8Array(byteNumbers);
          var file = new Blob([byteArray], { type: "application/pdf;base64" });
          var fileURL = URL.createObjectURL(file);
          //window.open(fileURL);
          var newwindow = window.open(
            fileURL,
            titulo,
            "height=" + h + ",width=" + w + ", top=" + 5 + ", left=" + left
          );

          if (window.focus) {
            newwindow.focus();
          }
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.showCargando = false;
        });
    },
    deleteRenta(rentaId) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR RENTA",
          "¿Estás seguro de eliminar la renta seleccionada?, la información relacionada a esta desaparecerá",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            rentaService
              .delete(rentaId)
              .then((result) => {
                var i = self.rentas.findIndex((obj) => obj.rentaId == rentaId);
                self.rentas.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text = "Renta eliminada con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                console.log(e);
                self.operationFailed(e);
              })
              .finally(() => {
                self.$store.state.loadingInfo.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onPagoAdded(rentaPago) {
      var renta = this.rentas.find((obj) => obj.rentaId == rentaPago.rentaId);
      renta.pagado += rentaPago.montoPago;
    },
    onPagoUpdated(rentaPago) {
      this.recalcularRenta(rentaPago);
    },
    onPagoDeleted(rentaPago) {
      this.recalcularRenta(rentaPago);
    },
    recalcularRenta(rentaPago) {
      let self = this;

      rentaService
        .getForGrid(rentaPago.rentaId)
        .then((result) => {
          var i = this.rentas.findIndex((obj) => obj.rentaId == result.rentaId);
          this.rentas.splice(i, 1, result);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    registroRecoleccionCliente(rentaId) {
      let self = this;

      self.rentaBitacora.rentaId = rentaId;
      self.rentaBitacora.eventoRentaId = 5;
      self.$store.state.tituloForm = "REGISTRAR RECOLECCIÓN CLIENTE";
      self.$store.state.iconoForm = "/images/general/agregar-40.png";
      self.$refs.formBitacoraRenta.openDialog();
    },
    registroCancelacion(rentaId) {
      let self = this;

      self.rentaBitacora.rentaId = rentaId;
      self.rentaBitacora.eventoRentaId = 11;
      self.$store.state.tituloForm = "REGISTRAR CANCELACIÓN RENTA";
      self.$store.state.iconoForm = "/images/general/agregar-40.png";
      self.$refs.formBitacoraRenta.openDialog();
    },
    onBitacoraAdded() {
      this.getRentas(this.sucursal.sucursalId);
    },
  },
};
</script>
